import React, { useState } from "react";
import PropTypes from "prop-types";
import JobDetails from "./JobDetail";
import responseTypes from "../../utils/responseTypes";

const MyJobs = ({ myJobs, completeJobHandler }) => {
  const [expandedJobs, setExpandedJobs] = useState(new Set());

  const toggleJob = (orderNumber) => {
    setExpandedJobs((prev) => {
      const next = new Set(prev);
      next.has(orderNumber) ? next.delete(orderNumber) : next.add(orderNumber);
      return next;
    });
  };

  return (
    <div className="row">
      <div className="col-md-12">
        {myJobs.length === 0 ? (
          <p className="fw-bold">You have no jobs to display</p>
        ) : (
          myJobs.map((job) => {
            const isExpanded = expandedJobs.has(job.orderNumber);
            return (
              <div key={job.orderNumber} className="card mb-3">
                <div
                  className="card-header"
                  onClick={() => toggleJob(job.orderNumber)}
                  style={{ cursor: "pointer" }}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <span style={{ fontSize: "0.9rem" }}>Ref: {job.orderNumber}</span>
                    <div className="d-flex align-items-center gap-2">
                      <span className="fw-bold" style={{ fontSize: "0.9rem" }}>
                        Job Value:{" "}
                        {new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(
                          job.engineerTotal
                        )}
                      </span>
                      <span style={{ fontSize: "0.8rem" }}>{isExpanded ? "▲" : "▼"}</span>
                    </div>
                  </div>
                  <div className="d-flex flex-column flex-md-row align-items-md-start mt-2">
                    <div className="d-flex flex-wrap gap-3 me-md-auto">
                      <span className="fw-medium" style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
                        <span className="text-muted fw-normal">Name: </span>{job.name.firstName} {job.name.lastName}
                      </span>
                      <span style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
                        <span className="text-muted">Install: </span>
                        {new Intl.DateTimeFormat("en-GB", { day: "2-digit", month: "short", year: "numeric" }).format(
                          new Date(job.installDate)
                        )}
                      </span>
                    </div>
                    <div className="d-flex flex-column align-items-stretch align-items-md-end mt-2 mt-md-0">
                      {job.orderStatus === responseTypes().STATUS_INSTALLED && (
                        <p className="fw-bold text-success mb-1" style={{ fontSize: "0.85rem" }}>
                          Installation Complete - Awaiting Documentation
                        </p>
                      )}
                      <div className="d-grid d-md-block">
                        <button
                          className="btn btn-success btn-sm"
                          value={job.orderNumber}
                          onClick={(e) => {
                            e.stopPropagation();
                            completeJobHandler(e);
                          }}
                        >
                          {job.orderStatus === responseTypes().STATUS_INSTALLED ? "Continue Completion" : "Complete Job"}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                {isExpanded && (
                  <JobDetails job={job} options={{ showPersonalInfo: true }} />
                )}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

MyJobs.propTypes = {
  myJobs: PropTypes.array.isRequired,
  completeJobHandler: PropTypes.func.isRequired,
};

export default MyJobs;
